import "./Location.css";

function Location() {
  return (
    <section className="section" id="location">
      <div className="container">
        <div className="row">
          <header className="col-12">
            <div className="section-heading heading-center">
              <div className="section-subheading">Onde Estamos</div>
              <h2>Nossa Localização</h2>
              <p className="section-desc">
                Venha nos visitar! Estamos localizados em Blumenau - SC.
              </p>
            </div>
          </header>

          <div className="col-12">
            <div className="map-wrapper">
              <iframe
                title="AMX Sistemas - Localização"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d308.0!2d-49.0683167!3d-26.889763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94df1f39990420d9%3A0xbe29e8de7f1083fc!2sAMX%20Sistemas!5e1!3m2!1spt-BR!2sbr!4v1712448000000!5m2!1spt-BR!2sbr"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>

              <div className="location-info">
                <div className="location-card">
                  <div className="location-card-icon">
                    <i className="material-icons material-icons-outlined md-48">location_on</i>
                  </div>
                  <div className="location-card-content">
                    <h4>Endereço</h4>
                    <p>Rua 7 de maio, 564<br />Itoupava Norte<br />Blumenau - SC</p>
                  </div>
                </div>
                <div className="location-card">
                  <div className="location-card-icon">
                    <i className="material-icons material-icons-outlined md-48">phone</i>
                  </div>
                  <div className="location-card-content">
                    <h4>Telefone</h4>
                    <p><a href="tel:+5547999876097">(47) 99987-6097</a></p>
                  </div>
                </div>
                <div className="location-card">
                  <div className="location-card-icon">
                    <i className="material-icons material-icons-outlined md-48">schedule</i>
                  </div>
                  <div className="location-card-content">
                    <h4>Horário</h4>
                    <p>Seg - Sex: 08:00 - 18:00<br />Sáb - Dom: Fechado</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Location;
